import UserGroupPicker from './UserGroupPicker'

export default UserGroupPicker
